import {
  Dialog,
  Box,
  Button,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import './InfoDialog.css';

interface Props {
  open?: boolean;
  title?: string;
  message?: string | null;
  cancelLabel?: string;
  onClose: (e: any) => void;
  content?: JSX.Element | null;
  size?: any
}

const InfoDialog: React.FC<Props> = ({
  open = true,
  title = '',
  message = '',
  cancelLabel = 'Entendido',
  content,
  onClose,
  size = 'xs'
}) => {
  return (
    <Dialog
      disableEnforceFocus
      className="InfoDialog-Container"
      open={open}
      onClose={onClose}
      maxWidth={size}
      fullWidth
    >
      <Box className="infoDialog-TitleBox">
        <Typography variant="h6" className="infoDialog-Title">
          {title}
        </Typography>
        <Button className="infoDialog-Close" id="infoDialog-Close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </Button>
      </Box>
      <Box className="infoDialog-ContentBox">
        {message}
        {content}
      </Box>
      <Box className="infoDialog-ButtonsBox">
        <Button
          autoFocus
          className={'infoDialog-Button infoDialog-Button-Default'}
          id="infoDialog-Button"
          variant="contained"
          onClick={onClose}
        >
          {cancelLabel}
        </Button>
      </Box>
    </Dialog>
  );
};

export default InfoDialog;
